export const locale = {
    lang: 'pt',
    data: {
      'CONFIGURACION': {
        'CABECERA':{
          'TITULO': 'CONFIGURAÇÃO',
          'DESCRIP': ''
        },
        'BOTONES':{
          'BOT1':{
            'TITULO': 'Carregar a lista de colaboradores',
            'BOTON': 'Estabelecer'
          },
          'BOT2':{
            'TITULO': 'Carregamento do logótipo da empresa',
            'BOTON': 'Estabelecer'
          },
          'BOT3':{
            'TITULO': 'Informação sobre requisitos técnicos',
            'BOTON': 'Ver mais...'
          }
        },
        'BD':{
          'TITUHEAD': 'Carregamento da base de dados dos colaboradores',
          'INFO': 'Carregue a base de dados de parceiros da sua empresa',
          'BOTONES':{
            'DescTemp': 'Descarregar modelo'
          },
          'MENSAJES':{
            'CARGABD': 'Carregar base de dados',
            'STATUS': 'ESTADO',
            'CORRECTO': 'A base de dados foi carregada correctamente',
            'ERROR': 'Ocorreu um erro ao carregar a base de dados'
          }
        },
        'LOGO':{
          'TITUHEAD': 'Carregamento do logótipo da empresa',
          'INFO': 'Carregue o logótipo da sua empresa',
          'MENSAJES':{
            'CARGA': 'Carregar logótipo',
            'STATUS': 'ESTADO',
            'CORRECTO': 'O logótipo foi carregado correctamente',
            'ERROR': 'Houve um erro ao carregar o logótipo'
          }
        },
        'REQTEC':{
          'TITUHEAD': 'Informação sobre requisitos técnicos',
          'INFO': 'Requisitos da plataforma para uma operação óptima',
          'MENSAJES':{
            'CARGA': '',
            'STATUS': 'ESTADO',
            'CORRECTO': 'Foi carregado correctamente',
            'ERROR': 'Houve um erro de carregamento '
          }
        }
      }
    }
};
